import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "full", "moreWrap", "lessWrap"]

  expand() {
    this.previewTarget.classList.add("hidden")
    this.fullTarget.classList.remove("hidden")
    this.moreWrapTarget.classList.add("hidden")
    this.lessWrapTarget.classList.remove("hidden")
  }

  collapse() {
    this.previewTarget.classList.remove("hidden")
    this.fullTarget.classList.add("hidden")
    this.moreWrapTarget.classList.remove("hidden")
    this.lessWrapTarget.classList.add("hidden")
  }
}
